import { render, staticRenderFns } from "./htmldialog.vue?vue&type=template&id=cf4687ae&scoped=true"
import script from "./htmldialog.vue?vue&type=script&lang=js"
export * from "./htmldialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4687ae",
  null
  
)

export default component.exports